export default __webpack_public_path__ + "static/media/money-back@2x.f6aaf6fc.png";